(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_auraa-cure-cards"] && !Shopify.designMode) return;
  try {
    (function() {
  document.addEventListener('click', function(e) {
    var card = e.target.closest('.acc-card');
    if (!card) return;
    e.preventDefault();

    // Trouver le nom de la variante depuis la carte (.acc-name)
    var nameEl = card.querySelector('.acc-name');
    if (!nameEl) return;
    var variantName = nameEl.textContent.trim();

    // Trouver l'input radio correspondant dans le variant-picker
    var picker = document.querySelector('variant-picker');
    if (!picker) return;
    var radio = picker.querySelector('input[value="' + variantName + '"]');
    if (!radio || radio.checked) return;

    // Sélectionner le radio et déclencher l'événement change
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));

    // Mettre à jour l'état visuel des cartes
    var grid = card.closest('.acc-grid');
    if (grid) {
      grid.querySelectorAll('.acc-card').forEach(function(c) {
        c.classList.remove('is-selected');
      });
      card.classList.add('is-selected');
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["auraa-cure-cards"] && !Shopify.designMode) return;
  try {
    (function(){
  function syncAvis(){
    var dataEl=document.querySelector('.auraa-avis-data');
    var avisEl=document.querySelector('.auraa-avis');
    if(dataEl&&avisEl){
      var v=dataEl.getAttribute('data-avis');
      if(v){var t=avisEl.matches('p')?avisEl:(avisEl.querySelector('p')||avisEl);t.textContent=v;}
    }
  }
  function highlight(vid){
    document.querySelectorAll('.auraa-cure-cards .acc-card').forEach(function(c){
      c.classList.toggle('is-selected', c.getAttribute('data-variant-id')===String(vid));
    });
  }
  function currentVid(){
    var r=document.querySelector('variant-picker input[type="radio"][data-variant-id]:checked');
    if(r) return r.getAttribute('data-variant-id');
    var s=document.querySelector('variant-picker select');
    if(s){var o=s.options[s.selectedIndex];if(o&&o.getAttribute('data-variant-id'))return o.getAttribute('data-variant-id');}
    var i=document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return i?i.value:null;
  }
  function klarnaEl(){return document.querySelector('.auraa-klarna');}
  function klarnaMap(){
    var k=klarnaEl(); if(!k) return null;
    try{return JSON.parse(k.getAttribute('data-cents-map'));}catch(e){return null;}
  }
  function placeKlarna(){
    var k=klarnaEl(); if(!k||k.getAttribute('data-placed')) return;
    var map=klarnaMap(); if(!map) return;
    var target=null;
    document.querySelectorAll('[data-ref="add-to-cart-button-container"]').forEach(function(c){
      if(target) return;
      var f=c.closest('form'); if(!f) return;
      var inp=f.querySelector('input[name="id"]');
      if(!inp || !Object.prototype.hasOwnProperty.call(map,inp.value)) return;
      var st=c.closest('sticky-add-to-cart');
      target=st||c;
    });
    if(!target) return;
    target.parentNode.insertBefore(k, target.nextSibling);
    k.hidden=false; k.setAttribute('data-placed','1');
  }
  function updateKlarna(){
    var k=klarnaEl(); if(!k) return;
    var map=klarnaMap(); if(!map) return;
    var vid=currentVid();
    var cents=(vid&&Object.prototype.hasOwnProperty.call(map,vid))?map[vid]:null;
    if(cents==null){for(var key in map){cents=map[key];break;}}
    if(cents==null) return;
    var amt=Math.round(cents/3)/100;
    var el=k.querySelector('.ak-amount');
    if(el) el.textContent=amt.toFixed(2).replace('.',',')+' €';
  }
  function syncFromPicker(){var v=currentVid();if(v)highlight(v);updateKlarna();}
  function removeDescTab(){
    var hosts=document.querySelectorAll('section-store--tabs-block');
    if(!hosts.length) return false;
    var done=true;
    hosts.forEach(function(h){
      var sr=h.shadowRoot;
      if(!sr){done=false;return;}
      var btns=sr.querySelectorAll('button.tab-button');
      if(!btns.length){done=false;return;}
      btns.forEach(function(b){
        if(/^\s*Description\s*$/i.test(b.textContent||'')) b.remove();
      });
    });
    return done;
  }
  function watchDescTab(){
    var tries=0;
    var iv=setInterval(function(){
      tries++;
      if(removeDescTab()||tries>40){clearInterval(iv);}
    },400);
  }
  function fixCompliance(){
    var map=[
      ['Fabrication française certifiée','Marque française'],
      ['Fabrication française dans des laboratoires certifiés GMP et HACCP','Marque française, fabrication en Europe dans des laboratoires certifiés ISO 9001 et HACCP']
    ];
    var w=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT,null);
    var n;
    while((n=w.nextNode())){
      var t=n.nodeValue;
      if(!t) continue;
      var changed=false;
      for(var i=0;i<map.length;i++){
        if(t.indexOf(map[i][0])>=0){t=t.split(map[i][0]).join(map[i][1]);changed=true;}
      }
      if(t.indexOf('cures longues')>=0&&t.indexOf('-25')>=0){t=t.split('-25').join('-15');changed=true;}
      if(changed) n.nodeValue=t;
    }
  }
  document.addEventListener('click', function(e){
    var card=e.target.closest('.auraa-cure-cards .acc-card');
    if(!card) return;
    e.preventDefault();
    var vid=card.getAttribute('data-variant-id');
    if(!vid) return;
    var radio=document.querySelector('variant-picker input[data-variant-id="'+vid+'"]');
    if(radio){
      if(!radio.checked){radio.checked=true;radio.dispatchEvent(new Event('change',{bubbles:true}));}
    } else {
      var form=document.querySelector('form[action*="/cart/add"]');
      if(form){form.querySelectorAll('input[name="id"]').forEach(function(inp){inp.value=vid;inp.dispatchEvent(new Event('change',{bubbles:true}));});}
    }
    highlight(vid);
    setTimeout(syncFromPicker,600);
  });
  document.addEventListener('change', function(e){
    if(e.target&&e.target.matches&&e.target.matches('variant-picker input, variant-picker select')){
      setTimeout(syncFromPicker,50);
      setTimeout(syncFromPicker,600);
    }
  });
  function init(){syncAvis();placeKlarna();syncFromPicker();updateKlarna();watchDescTab();fixCompliance();setTimeout(fixCompliance,1500);}
  if(document.readyState!=='loading'){init();}else{document.addEventListener('DOMContentLoaded',init);}
})();
  } catch(e) { console.error(e); }
})();

})();
